import { IResponse } from '@estee/elc-http-transport';

import { ICollection as ICollectionResponse, IPGResponse } from '~api/CartAPI/ICartApiSdk';
import { ICollection } from '~domain/entities/Collection/ICollection';

export const findCollectionInCollectionResponse = (
    collectionName: string,
    response: IResponse<IPGResponse<ICollectionResponse>[]>
) =>
    (response.data?.find(
        (dataSet) => dataSet?.result?.value?.collection?.COLLECTION_NAME === collectionName
    )?.result?.value || {}) as ICollection;
